import { Controller } from "@hotwired/stimulus";

// Zone de saisie GO4SIA (§13.7) : Entrée = envoyer, Maj+Entrée = nouvelle ligne,
// auto-extension, réinitialisation après envoi sans perte de focus.
export default class extends Controller {
  static targets = ["input", "send"];

  keydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      if (this.inputTarget.value.trim() !== "") {
        this.element.requestSubmit();
      }
    }
  }

  grow() {
    this.inputTarget.style.height = "auto";
    this.inputTarget.style.height = `${Math.min(this.inputTarget.scrollHeight, 160)}px`;
  }

  reset(event) {
    if (event.detail?.success) {
      this.inputTarget.value = "";
      this.inputTarget.style.height = "auto";
      this.inputTarget.focus();
    }
  }
}
